export default __webpack_public_path__ + "static/media/port6.89d1dd25.jfif";